import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../shared/utility";

const initialState = {
  liveParticipants: null,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_LIVE_PARTICIPANTS:

      return updateObject(state, {
        liveParticipants: action.payload,
      });

    case actionTypes.INITI_LIVE_PARTICIPANT_DATA:

      return updateObject(state, {
        liveParticipants: null,
      });

    default:
      return state;
  }
};

export default reducer;
